<template>
  <v-dialog v-model="dialog" max-width="980" @click:outside="close">
    <v-card>
      <v-card-title class="d-flex align-center">
        <span class="text-h6">{{ $t('tanaoroshiSai.popup.title') }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-6">
        <v-row>
          <v-col cols="12">
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.janCode') }}{{ dialogData.janCode || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.productName') }}{{ dialogData.productName || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.productCode') }}{{ dialogData.productCode || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.colorCode') }}{{ dialogData.colorCode || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.colorName') }}{{ dialogData.colorName || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.sizeCode') }}{{ dialogData.sizeCode || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('zaikoEpcList.label.sizeName') }}{{ dialogData.sizeName || '-' }}
            </v-chip>
            <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
              {{ $t('tanaoroshiSai.label.table.planSuuryo') }}：{{ dialogData.planSuuryo ?? '-' }}
            </v-chip>
          </v-col>
        </v-row>

        <v-progress-linear
          v-if="dialogData.loading"
          indeterminate
          color="blue"
          class="mb-4"
        ></v-progress-linear>

        <v-table v-else density="compact" class="text-no-wrap">
          <thead>
            <tr>
              <th>{{ $t('tanaoroshiSai.popup.table.no') }}</th>
              <th>{{ $t('tanaoroshiSai.popup.table.zoneName') }}</th>
              <th>{{ $t('tanaoroshiSai.popup.table.resultSuuryo') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in dialogData.locationList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ row.zoneName || '-' }}</td>
              <td>{{ row.resultSuuryo ?? '-' }}</td>
            </tr>
            <tr v-if="dialogData.locationList.length === 0">
              <td :colspan="3" class="text-center grey--text">
                {{ $t('tanaoroshiSai.popup.noData') }}
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogData: {
      type: Object,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },
  methods: {
    close() {
      this.handleClose();
    },
  },
};
</script>
